// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__p9jlt","message":"Alert_message__jVN3x"};